module.exports = __webpack_public_path__ + "img/2.8e3b4501.jpg";